// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "./translations"; // pull in your massive translations object
import supportedLanguages from '../utils/SupportedLanguages';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const storedLang = localStorage.getItem('lang') || 'en';
  const [currentLanguage, setCurrentLanguage] = useState(storedLang);

  const currentLangMeta = supportedLanguages.find(lang => lang.code === currentLanguage) || {};
  const direction = currentLangMeta.direction || 'ltr';
  const isRtl = direction === 'rtl';
  const t = (key) =>
    translations[currentLanguage]?.[key] || translations['en'][key] || key;
  const changeLanguage = (langCode) => {
    localStorage.setItem('lang', langCode);
    setCurrentLanguage(langCode);
  };

  const getLanguageName = (code) => {
    return supportedLanguages.find((lang) => lang.code === code)?.name || code;
  };

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      direction,
      isRtl,
      getLanguageName,
      supportedLanguages,
      t
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
